import { useFormikContext } from "formik";
import React from "react";

import { handleDownloadFile } from "../utils/helperFunctions";
import trash from "../assets/misc/trash.png";
import Pathpin from "../assets/misc/pdfimg.png";

const FilePreview = ({
  pathNameLabel,
  fileNameLabel,
  showTrashIcon,
  pathValue,
  showViewIcon,
}) => {

  const { setFieldValue, values } = useFormikContext();
  const handleViewFile = (file) => {
    if (file instanceof File) {
      // Create a blob URL for the new file and open it in a new tab
      const fileUrl = URL.createObjectURL(file);
      window.open(fileUrl, "_blank");
    } else {
      // If it's an existing file (already uploaded), download using its URL
      handleDownloadFile(file, fileNameLabel);
    }
  };

  return (
    <div className="form-control d-flex justify-content-between align-items-center">
      <div className="center-alignment">
        <div>
          <img className="" width={26} src={Pathpin} alt="PDF" />
        </div>
        <div className="ms-3">
          {fileNameLabel.includes("https://")
            ? "File"
            : fileNameLabel
                .replace(/_/g, " ") // Replace underscores with spaces
                .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first character after space
                .replace(/\bssm\b/gi, "SSM")}
        </div>
        {showViewIcon !== 0 && (
          <div
            className="d-flex align-items-center px-3 text-gray-300 cursor-pointer"
            style={{
              height: "33px",
              borderRadius: "4px",
            }}
            // onClick={() => {
            //   const path =
            //     pathValue == 0 ? pathNameLabel : values[pathNameLabel];
            //   handleDownloadFile(path, values[fileNameLabel]);
            // }}
            onClick={() => {
              const path =
                pathValue == 0 ? pathNameLabel : values[pathNameLabel];
              handleViewFile(path);
            }}
          >
            <i className="text-primary-sapphire fw-600 text-decoration-underline">
              View
            </i>
          </div>
        )}
      </div>
      {showTrashIcon !== 0 && (
        <img
          src={trash}
          alt="Delete"
          className="cursor-pointer"
          onClick={() => {
            setFieldValue(pathNameLabel, "");
            setFieldValue(fileNameLabel, "");
          }}
        />
      )}
    </div>
  );
};

export default FilePreview;
